// App-wide UI state for M3 snackbars + confirm dialogs. Mount <UiHost />
// once near the app root; everywhere else just calls ui.snack(...) / ui.ask(...).
//
// snack(text, kind?)        -> shows a snackbar; kind: 'info' (default) | 'error' | 'success'
// ask({ title, message? })  -> opens a confirm dialog; returns a Promise<boolean>

class UI {
  snackbar = $state(null);
  confirm  = $state(null);

  // timeoutMs null = pick by kind: errors stay until dismissed (you usually
  // need to read/copy them), everything else auto-dismisses after 4s. Pass an
  // explicit number to override (e.g. a quick 1.5s "copied" confirmation).
  snack(text, kind = 'info', timeoutMs = null) {
    this.snackbar = { text, kind, key: Date.now() };
    const ms = timeoutMs == null ? (kind === 'error' ? 0 : 4000) : timeoutMs;
    if (ms > 0) {
      const k = this.snackbar.key;
      setTimeout(() => { if (this.snackbar?.key === k) this.snackbar = null; }, ms);
    }
  }
  dismissSnack() { this.snackbar = null; }

  ask({ title, message = '', confirmText = 'Confirm', cancelText = 'Cancel', destructive = false }) {
    return new Promise((resolve) => {
      this.confirm = { title, message, confirmText, cancelText, destructive, resolve };
    });
  }
  resolveConfirm(answer) {
    const r = this.confirm?.resolve;
    this.confirm = null;
    r?.(answer);
  }
}

export const ui = new UI();
